/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

export type ConsultCallback = (password: string) => void | Promise<void>;

let callback: ConsultCallback | null = null;

/**
 * The care screener hands the password-reset pages a continuation: after a successful reset the
 * screener logs the family in with the new password and returns to the consult. Held here rather
 * than in the tiny-atom store so the auth pages need no store at all.
 */
export function setConsultCallback(next: ConsultCallback | null): void {
  callback = next;
}

export function getConsultCallback(): ConsultCallback | null {
  return callback;
}
